// @core/api/endpoints/secret/tune_engine.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SecretEngineResponse,
  TuneEngineRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Tune secrets engine
 * Updates engine configuration (TTLs, caching, seal wrap). Does not change the engine type or mount path.
 */
export async function TuneEngine(
  engine_id: string,
  data: TuneEngineRequest,
  options?: RequestOptions
): Promise<SecretEngineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.patch<SecretEngineResponse>(requestPath, data, requestOptions);
}
